export const KEY_ESCAPE = 27;